import AgoraRTC, { AgoraRTCProvider } from "agora-rtc-react";
import ScreenSharing from "../ScreenSharing";
import Call from "../Call";
import ExternalCamera from "components/ExternalCamera";

const CallScreen = () => {
  const videoClient = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });
  const externalCameraClient = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });
  const screenClient = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

  return (
    <>
      <AgoraRTCProvider client={videoClient}>
        <Call />
      </AgoraRTCProvider>
      <AgoraRTCProvider client={externalCameraClient}>
        <ExternalCamera />
      </AgoraRTCProvider>
      <AgoraRTCProvider client={screenClient}>
        <ScreenSharing />
      </AgoraRTCProvider>
    </>
  );
};

export default CallScreen;
